export default "__VITE_ASSET__DoEZSbZz__"